export const StorageKey = {
    cognitoId: "cid",
    socialType: 'socialType',
    accessToken: 'at',
    idToken: 'it',
    isSocialIntegration: 'isSocialIntegration',
    mgToken: 'mgToken',
    pagerInfo: 'pageInfo',
    pagerContentInfo: 'pagerContentInfo'
}